import React, { useEffect, useState } from "react";
import Checkout from "./CheckOut";
import "./CartModal.css";

function CartModal({ onClose }) {
  const [cartItems, setCartItems] = useState([]);
  const [showCheckout, setShowCheckout] = useState(false);
  const [showEmptyMessage, setShowEmptyMessage] = useState(false);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("cart") || "[]");
    setCartItems(saved);
  
    if (saved.length === 0) {
      setShowEmptyMessage(true);
      const timer = setTimeout(() => {
        setShowEmptyMessage(false);
        onClose(); // Chiude la modale
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);
  
  const getTotal = () => {
    return cartItems.reduce((sum, item) => sum + (item.price || 0), 0);
  };

  const handleRemove = (index) => {
    const updatedCart = cartItems.filter((_, i) => i !== index);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCartItems(updatedCart);
    window.dispatchEvent(new Event("cartUpdated"));
  
    if (updatedCart.length === 0) {
      setShowEmptyMessage(true);
      setTimeout(() => {
        setShowEmptyMessage(false);
        onClose(); // Chiude la modale
      }, 2000);
    }
  };
  const handleClearCart = () => {
    localStorage.removeItem("cart");
    setCartItems([]);
    window.dispatchEvent(new Event("cartUpdated"));
  
    setShowEmptyMessage(true);
    setTimeout(() => {
      setShowEmptyMessage(false);
      onClose(); // Chiude la modale
    }, 2000);
  };

  if (showCheckout) {
    return <Checkout total={getTotal()} onClose={onClose} cartItems={cartItems} />;
  }

  return (
    <div className="cart-modal-overlay" onClick={onClose}>
      <div className="cart-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Carrello</h2>
        <div className="cart-items" style={{display:"grid"}}>
          {cartItems.length === 0 && showEmptyMessage ? (
            <p style={{textAlign:'center'}}>Il carrello è vuoto.</p>
          ) : (
            cartItems.map((item, i) => (
              <div key={i} className="cart-item">
                <img src={item.src} alt={item.alt} />
                <div style={{ flex: '1' }}>
                  <span>{item.alt}</span>
                  <div style={{ fontSize: "0.9rem", color: "#666", marginTop: 4 }}>
                    <div>Dimensioni: {item.fullwidth}x{item.fullheight} pixel</div>
                    <div>Nome file: {item.filename}</div>
                  </div>
                  <div style={{ fontSize: "1rem", fontWeight: "bold", marginTop: 4 }}>
                    €{item.price?.toFixed(2)}
                  </div>
                </div>
                <button
                  onClick={() => handleRemove(i)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#cc0000",
                    fontSize: "20px",
                    cursor: "pointer",
                    width: "50px"
                  }}
                  title="Rimuovi immagine"
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            ))
          )}
        </div>

        {cartItems.length > 0 && (
          <>
            <div className="cart-total">Totale: €{getTotal().toFixed(2)}</div>
            <div style={{ display: "flex", justifyContent: "space-evenly" ,padding:"10px"}}>
              <button 
                onClick={handleClearCart}
                style={{
                  backgroundColor: "#cc0000",
                  margin: "10px",
                  width: "150px"
                }}
              >
                Svuota carrello
              </button>
              <button 
                onClick={onClose}
                style={{ margin: "10px", width: "150px" }}
              >
                Chiudi
              </button>
              <button 
                onClick={() => setShowCheckout(true)}
                style={{
                  backgroundColor: "#0070f3",
                  color: "#fff",
                  margin: "10px",
                  width: "150px"
                }}
              >
                Checkout
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CartModal;
